const storagePrefix = 'studiocast_react_';

const storage = {
  getToken: () => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}token`) as string);
  },
  setToken: (token: string) => {
    window.localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
  },
  setTheme: (theme: string) => {
    window.localStorage.setItem('theme', theme);
  },
  getTheme: () => {
    return window.localStorage.getItem('theme');
  },
  setSidebarOpenState: (state: boolean) => {
    window.localStorage.setItem('sidebarOpen', state ? 'true' : 'false');
  },
  getSidebarOpenState: () => {
    return window.localStorage.getItem('sidebarOpen') === 'true';
  },
  setExpiration: (expiration: number) => {
    window.localStorage.setItem('token_expiration', expiration.toString())
  },
  getExpiration: () => {
    return window.localStorage.getItem('token_expiration')
  }
};

export default storage;
